var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.75C0 0.335786 0.335786 0 0.75 0H9C9.41421 0 9.75 0.335786 9.75 0.75C9.75 1.16421 9.41421 1.5 9 1.5H1.5V16.5H16.5V9C16.5 8.58579 16.8358 8.25 17.25 8.25C17.6642 8.25 18 8.58579 18 9V17.25C18 17.6642 17.6642 18 17.25 18H0.75C0.335786 18 0 17.6642 0 17.25V0.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8697 0.219661C14.1626 -0.0732321 14.6375 -0.0732321 14.9304 0.219661L17.7588 3.04809C17.8994 3.18874 17.9785 3.37951 17.9785 3.57842C17.9785 3.77733 17.8994 3.9681 17.7588 4.10875L10.5664 11.3011C10.4257 11.4418 10.235 11.5208 10.0361 11.5208L7.20764 11.5208C7.00872 11.5208 6.81796 11.4418 6.67731 11.3011C6.53665 11.1605 6.45764 10.9697 6.45764 10.7708L6.45764 7.94238C6.45764 7.74347 6.53665 7.5527 6.67731 7.41205L13.8697 0.219661ZM14.4 1.81065L7.95764 8.25304V10.0208L9.7254 10.0208L16.1678 3.57842L14.4 1.81065Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditItem);
export default __webpack_public_path__ + "static/media/edit-item.6cf0b509b26b4aae68bccba0d4e09d64.svg";
export { ForwardRef as ReactComponent };